export default "__VITE_ASSET__17aef510__"